module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-001",
      "role": "doc-chapter"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "role": "doc-pagebreak",
      "title": "1"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Image",
      "id": "fig-014_1",
      "src": "images/spectrum_bar_gray.jpg"
    }
  })])]), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Introduction to Covenantal and Dispensational Theologies ")])]), _c('h1', {
    staticClass: "chap_stit2",
    attrs: {
      "epub:type": "subtitle",
      "role": "doc-subtitle"
    }
  }, [_c('span', [_c('b', [_vm._v("Four Views on the Continuity of Scripture")])])]), _c('h1', {
    staticClass: "chap_sstit",
    attrs: {
      "epub:type": "subtitle",
      "role": "doc-subtitle"
    }
  }, [_c('span', [_c('i', [_vm._v("BRENT E. PARKER AND RICHARD J. LUCAS")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "mev1"
  }, [_c('b', [_vm._v("One of the most complex and difficult issues")])]), _vm._v(" for Bible readers, particularly those who acknowledge the Bible as the Word of God with one divine author, is understanding how the whole canon fits together. Does the Bible have a unified and cohesive plan? Can a unity be maintained given the theological diversity within Scripture? For evangelical Christians who accept that God is the ultimate author of Scripture, the Bible being the work of human authors through the operation of the Holy Spirit as they freely wrote what God superintended, Scripture does have an overarching metanarrative and unified message and plan that is disclosed through the progress of revelation. Scripture consists of a central storyline that unfolds over time as the plot develops through history, often through surprising twists and turns. The biblical authors build on and add to what earlier authors wrote even as earlier authors sometimes projected the wonders to come (1 Pet 1:10-12). Given the nature of Scripture as progressive revelation, the task of biblical theology is not optional; careful Bible readers must examine how the individual parts of the Bible fit within the whole and seek to explain the theological relationship between earlier and later portions of Scripture."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-001",
      "id": "ap_ntb-001-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "role": "doc-pagebreak",
      "title": "2"
    }
  }, [_vm._v("Nevertheless, how one accounts for the individual biblical texts, observes the development of the narrative and various themes at different stages in the canon, and goes about formulating theological conclusions, all the while seeking to do justice to the whole Bible and the parts, is a difficult theological task and one that is subject to much debate. Particularly with the coming, resurrection, and ascension of Jesus Christ, and the descent of the Holy Spirit, the interpreter must decide what Christ and the newness that results from his work on the cross means with respect to past revelation and how and to what extent the Old Testament (OT) is fulfilled. Not surprisingly, evangelicals propose systems of theology that they argue best reflect the whole Bible, given how it is structured and interwoven. These systems of theology differ significantly, especially in the areas of ecclesiology (not least of all in church practices such as baptism) and eschatology (e.g., does God still have a plan for national, political Israel?). But such debates are inevitable for any serious and thoughtful reader of the Bible as he or she must think through the storyline of Scripture, put the Bible together, and come to conclusions regarding the progress of revelation and the relationship between OT and New Testament (NT). There is agreement that biblical theology is critically important, but the actual doing or practice of biblical theology varies, which in turn leads to very different theological systems and conclusions. In fact, disagreement about what the whole Bible says regarding the kingdom of God, the nature of the church, end times, how the OT law relates to believers in Christ, particularly the Sabbath, and the meaning of baptism, are just some of the issues where competing biblical-systematic theological conclusions have led to the formation of different denominations. The canon of Scripture demands such reflection, and "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "role": "doc-pagebreak",
      "title": "3"
    }
  }, [_vm._v("evangelicals have come to different conclusions, advocating and promoting covenantal and dispensational theologies among other formulations for how the Bible is put together.")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The task of this book is to explore evangelical systems of theology. The focus will not be placed entirely on particulars such as the relationship between Israel and the church, though that is where vociferous debate has emerged, and this topic will be addressed in the chapters of this volume."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-002",
      "id": "ap_ntb-002-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Instead, the primary goal of this work is broader in forging discussion and reflection regarding one’s interpretative approach and hermeneutic for putting together the OT and NT and, in turn, to determine why one’s particular system of theology should be viewed as the most biblical and faithful to the whole canon. At the center of this debate is how one structures biblical revelation and, particularly, draws conclusions regarding the biblical covenants and their relationship to one another. How the grand sweep of redemptive history colors one’s view of the continuity and discontinuity between the testaments with the coming of Jesus Christ is of paramount importance."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-003",
      "id": "ap_ntb-003-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Crucial to the debate are the covenants, for as Scott Hafemann has observed, the “concept of the covenant relationship provides the "), _c('i', [_vm._v("structure")]), _vm._v(" that serves to integrate the interrelated themes developed throughout the history of redemption delineated in the Scriptures.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-004",
      "id": "ap_ntb-004-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Stated differently, one does not have to affirm that the covenant is the central concept or organizing principle of biblical theology to recognize that the outworking of the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "role": "doc-pagebreak",
      "title": "4"
    }
  }, [_vm._v("biblical covenants results in major conclusions for the issues of continuity and discontinuity. Even for those who structure biblical revelation by identifying different epochs or dispensations other than the covenants (or who focus on other key structural themes, such as the kingdom of God) acknowledge that the interpretation of the biblical covenants is fundamental in the formulation of their system of theology. In other words, how one interprets the covenant of creation (if there is such a covenant), the covenant with Noah, the covenant with Abraham and the patriarchs, the covenant with Israel (also known as the Mosaic covenant or covenant at Sinai), the Davidic covenant, and the new covenant, and especially how one processes the interrelationships of the covenants, inevitably leads to massive theological conclusions. Formulating a whole Bible system of theology depends heavily on what one does with the covenants and how one connects them to the person and work of Jesus Christ.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("OVERVIEW OF THEOLOGICAL SYSTEMS")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since the Protestant Reformation, numerous ways have been proposed for understanding the relationship between the Old and New Testaments and to account for the continuity and discontinuity of Scripture. Not every position or proposal can possibly be covered. For the purposes of this book, four of the most major and popular schemes of theology are debated. These views are covenant theology, progressive covenantalism, progressive dispensationalism, and a more traditional version of dispensational theology."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-005",
      "id": "ap_ntb-005-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" These four views range on the spectrum from advancing more continuity in the plan of God through the OT to the NT (covenant theology and progressive covenantalism) to advocating more discontinuity (progressive and traditional dispensationalism).")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Covenant theology.")])]), _vm._v(" Covenant theology (also known as Reformed or “federal” theology) is a system of theology that places significant stress on the covenants and the concept of covenant. The covenants are the “architectonic structure” that provide the context for understanding the unity of the Bible "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "role": "doc-pagebreak",
      "title": "5"
    }
  }, [_vm._v("amid its diversity."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-006",
      "id": "ap_ntb-006-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" Emphasis is placed on Adam and Christ as the two covenant heads between God and human beings. While covenant theology is often associated with Johannes Cocceius (1603–1669) and Herman Witsius (1636–1708), the doctrine of the covenant appears in patristic and medieval thought before becoming significant in the early Reformation period and in the post-Reformation era, where federal theology seems to have crystalized in the theology of Zacharias Ursinus (1534–1583) and Caspar Olevianus (1536–1587)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-007",
      "id": "ap_ntb-007-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" According to Robert Letham, the covenant notion received detailed attention in the sixteenth century because of the Anabaptist challenge to infant baptism."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-008",
      "id": "ap_ntb-008-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" A defense of infant baptism was provided through the unity of the covenant, with the practice of circumcision for Abraham’s offspring being analogous to the practice of baptism in the NT.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In Reformed federal or covenant theology, three covenants are set forth that undergird this system. R. Scott Clark explains: “Those three covenants are (1) the pretemporal covenant of redemption ("), _c('i', [_vm._v("pactum salutis")]), _vm._v(") between the Father and the Son, (2) a historical covenant of works between God and Adam as the federal head of humanity ("), _c('i', [_vm._v("foederus operum")]), _vm._v("), and (3) a covenant "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "role": "doc-pagebreak",
      "title": "6"
    }
  }, [_vm._v("of grace ("), _c('i', [_vm._v("foederus gratiae")]), _vm._v(") with the elect, in Christ, administered through a series of covenants from Adam to Christ.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-009",
      "id": "ap_ntb-009-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The foundation of the covenant of works and the covenant of grace is the covenant of redemption. The intra-trinitarian covenant of redemption, or counsel of peace, posits that the Father elected a people in the Son, who is the guarantor and mediator of their redemption through his incarnation, obedience, death, resurrection, and ascension. The covenant of redemption is also rooted in the Spirit’s role both in equipping the Son for his mission and in applying the finished work of Christ to the elect."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-010",
      "id": "ap_ntb-010-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Lately, the covenant of redemption has been challenged."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-011",
      "id": "ap_ntb-011-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Nevertheless, for the purposes of this book in presenting covenant theology as a viewpoint, the covenant of works and covenant of grace are emphasized more since the issue of continuity and discontinuity centers more on the covenants established in history.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("The covenant of works.")]), _vm._v(" Essential to covenant theology is the covenant of works, which is sometimes known as the covenant of creation, nature, or law. Covenant theologians start with the opening chapters of Genesis for framing the overarching narrative of Scripture as Adam is viewed as the federal head of humanity."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-012",
      "id": "ap_ntb-012-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Offering a succinct description of the covenant works, Charles Hodge writes:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "role": "doc-pagebreak",
      "title": "7"
    }
  }, [_vm._v("God having created man after his own image in knowledge, righteousness, and holiness, entered into a covenant of life with him, upon condition of perfect obedience, forbidding him to eat of the tree of knowledge of good and evil upon the pain of death. According to this statement, (1) God entered into a covenant with Adam. (2) The promise annexed to that covenant was life. (3) The condition was perfect obedience. (4) Its penalty was death."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-013",
      "id": "ap_ntb-013-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Hodge’s description indicates that the covenant of works is a conditional covenant of love and law. Adam, created in a state of innocence and “in a state of positive righteousness—with all of its requisite natural and moral abilities to fulfill the commission entrusted to him”—was situated in a probationary test or trial period such that his obedience and covenant loyalty and love would have merited him the right to eat from the Tree of Life, implicitly meaning that God would confirm him in everlasting peace and "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "role": "doc-pagebreak",
      "title": "8"
    }
  }, [_vm._v("righteousness."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-014",
      "id": "ap_ntb-014-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" The covenant was legal in nature, for the stipulation entailed the penalty of death for disobedience (Gen 2:17). Since Adam was not just the natural head of a humanity, but the federal head or legal representative of all humanity, his transgression broke the covenant, and the guilt associated with Adam’s actions were imputed to his children. The covenant of works is important not only for the doctrine of sin but also for the principle of corporate solidarity with persons being either in union with Adam or with Christ. The active obedience of Christ, with Christ perfectly satisfying the law of God in his life as a representative of his people, and the law/gospel distinction that weaves through both the OT and NT, both receive their foundation in Reformed theology through the doctrine of the covenant of works.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("The covenant of grace.")]), _vm._v(" The defining characteristic of covenant theology as a system that emphasizes continuity is based on the understanding of the overarching covenant of grace, which stands as the framework for the whole progress of revelation following the fall. Genesis 3 through the book of Revelation unfolds God’s plan of redemption in history as God, now appearing as Redeemer and Father, promises a Savior who will undo the curses of sin by graciously rescuing a people, all of which is ultimately realized in Jesus Christ’s obedience and atoning work."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-015",
      "id": "ap_ntb-015-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" While the historical "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "role": "doc-pagebreak",
      "title": "9"
    }
  }, [_vm._v("inauguration of the covenant of grace occurs with the gracious promise of a seed, a second Adam who will crush the head of the serpent (Gen 3:15) and thus become the basis for all the post-fall divine-human covenants (Noahic, Abrahamic, Mosaic, Davidic, and the new), the covenant of grace is grounded in and flows out of the covenant of redemption from eternity past, historically unfolding the way of salvation throughout the testaments in terms of justification by faith alone through the mediator of this covenant, Jesus Christ."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-016",
      "id": "ap_ntb-016-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" The gospel, which is the revelation of the covenant of grace, is the same throughout the storyline of Scripture, and therefore there is one covenant of grace. To maintain the unity of the covenant of grace while also recognizing the different covenants throughout the OT and NT, covenantalists make a fundamental distinction between the substance and administrations of the covenant of grace. In other words, the same covenant of grace was dispensed in diverse manners. Turretin explains that the covenant of grace had various forms and faces, as it were, on account of the varied economy of the mystery of Christ (who is its foundation), which God so willed to administer as to propose it at first somewhat obscurely and then more clearly, first in the promise and then in the fulfillment."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-017",
      "id": "ap_ntb-017-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Clearer manifestations of the covenant of grace are revealed through redemptive history, but the "), _c('i', [_vm._v("protoevangelium ")]), _vm._v("(Gen 3:15), Noahic, Abrahamic, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "role": "doc-pagebreak",
      "title": "10"
    }
  }, [_vm._v("Mosaic, Davidic, and new covenants are all administrations of the covenant of grace. Although these covenants differ in their accidental properties (nonessential parts) and are diverse and particular in terms of mode, according to covenant theologians, they all profoundly agree in their substance."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-018",
      "id": "ap_ntb-018-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" Stated differently, the substance of the covenant of grace or the central redemptive subject matter is Jesus Christ, denoting the “christocentric strand inherent in redemptive revelation.” The administrations of the covenant of grace, moving from promises, types, and shadows to the fulfillment in Christ, denote the christotelic strand. Thus from the Reformed perspective, the christocentric and christotelic inform one another and are mutually reinforcing."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-019",
      "id": "ap_ntb-019-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Although there are points of dispute among covenant theologians, especially in regard to whether the Mosaic covenant is a republication of the covenant of works,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-020",
      "id": "ap_ntb-020-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" the overview above shows that all of redemptive history "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "role": "doc-pagebreak",
      "title": "11"
    }
  }, [_vm._v("is framed by the covenant of works and grace. The result leads to affirming much unity and continuity between the testaments, which is crucial for theological conclusions. Israel and the church are one essentially: the covenant community consisting of believers and unbelievers (visible-invisible church distinction) and their children is the same throughout the covenant of grace, and there is a continuity of covenant signs (children enter the covenant through circumcision in the OT and baptism in the NT, and circumcision signifies the same spiritual realities as baptism). Covenant theologians also tend to be amillennial or postmillennial in their eschatological outlook as well; nevertheless, there would be broad if not unanimous affirmation of inaugurated eschatology (the "), _c('i', [_vm._v("already-not yet")]), _vm._v(" tension expressed in the NT) as many covenant theologians have stressed that the kingdom has "), _c('i', [_vm._v("already")]), _vm._v(" arrived with the coming of Christ, while the fullness of the kingdom is "), _c('i', [_vm._v("not yet")]), _vm._v(" consummated until Christ’s return.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Dispensationalism.")])]), _vm._v(" Beside covenant theology, the other major evangelical system of theology is dispensationalism. Dispensationalism is a popular evangelical movement, especially in the United States. Many dispensational seminaries and schools have thrived with their emphasis on biblical prophecies, the nation of Israel, the rapture, and the millennium. These emphases have been spread also through books, movies, and other media."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-021",
      "id": "ap_ntb-021-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" The name "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "role": "doc-pagebreak",
      "title": "12"
    }
  }, [_vm._v("“dispensationalism” is derived from the noun “dispensation,” a translation of the Greek word "), _c('span', {
    staticClass: "mev4"
  }, [_vm._v("ο")]), _c('span', {
    staticClass: "mev3"
  }, [_vm._v("ἰ")]), _c('span', {
    staticClass: "mev4"
  }, [_vm._v("κονομ")]), _c('span', {
    staticClass: "mev3"
  }, [_vm._v("ί")]), _c('span', {
    staticClass: "mev4"
  }, [_vm._v("α")]), _vm._v(" (Eph 1:10; 3:2; 1 Cor 9:17; Col 1:25; 1 Tim 1:4), meaning administration, stewardship, or the management of a household."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-022",
      "id": "ap_ntb-022-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" Although dispensationalism cannot be defined based on the term or concept of dispensation,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-023",
      "id": "ap_ntb-023-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" dispensations as distinguishable economies or periods of time during which God dispenses or administers his plan of redemption in ways different from other epochs or eras is important to dispensationalists and their system as a whole."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-024",
      "id": "ap_ntb-024-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" For covenant theologians, the role of covenant is paramount for structuring the unity of the Bible, but “unlike covenantalists, [dispensationalists] do not believe that the ‘covenant’ establishes the framework of the biblical story. This does not mean that dispensationalists deny the importance of covenants . . . but that they believe that covenants are subsidiary to another structural construction.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-025",
      "id": "ap_ntb-025-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("What dispensational framework is understood to account for all of redemptive history differs among dispensational scholars. For more traditional "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "role": "doc-pagebreak",
      "title": "13"
    }
  }, [_vm._v("or classic dispensationalists following C. I. Scofield, there are seven distinct dispensations: Innocency, Conscience, Human Government, Promise, Mosaic, Grace, and Kingdom/millennium."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-026",
      "id": "ap_ntb-026-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" For contemporary progressive dispensationalists, the number of dispensations also varies, with some advocating for four, and others observing as many as seven."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-027",
      "id": "ap_ntb-027-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" Regardless of the number of dispensations, how dispensationalists do biblical theology leads them to similar conclusions regarding ecclesiology and eschatology.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("All dispensationalists reject what they describe as “supersessionism” or “replacement theology.” Although Christ may be identified with Israel in some versions of dispensationalism, such a relationship does not transcend or remove the idea of Israel and the future restoration of national Israel or the OT hopes concerning Israel’s Promised Land."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-028",
      "id": "ap_ntb-028-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" The church does not supersede the nation of Israel, even as they share a similar identity as the people of God. The Israel/church distinction is the defining mark of dispensationalism. Undergirding this essential tenet are hermeneutical presuppositions regarding the progress of revelation, typology, the NT use of the OT, and understanding the fulfillment of OT covenant promises and prophecies to Israel unconditionally and “literally.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-029",
      "id": "ap_ntb-029-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" Probably the best treatment of what constitutes the foundational beliefs of dispensationalism is the one offered by Michael Vlach. After evaluating the core principles provided by "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "role": "doc-pagebreak",
      "title": "14"
    }
  }, [_vm._v("Charles Ryrie, John Feinberg, and Craig Blaising and Darrell Bock, Vlach elucidates six points that constitute the essence of dispensational theology:")])]), _c('ol', {
    staticClass: "liste_num_point"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("1")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" Progressive revelation from the NT does not interpret OT passages in a way that cancels the original authorial intent of the OT writers as determined by historical-grammatical hermeneutics.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("2")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" Types exist, but national Israel is not a type that is superseded by the church.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("3")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" Israel and the church are distinct; thus, the church cannot be identified as the new or true Israel.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("4")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" There is both spiritual unity in salvation between Jews and Gentiles and a future role for Israel as a nation.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("5")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" The nation Israel will be saved, restored with a unique identity, and function in a future millennial kingdom on the earth.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("6")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" There are multiple senses of “seed of Abraham”; thus, the church’s identification as “seed of Abraham” does not cancel God’s promises to the believing Jewish “seed of Abraham.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-030",
      "id": "ap_ntb-030-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Over the past thirty years, two varieties of dispensationalism have stood out in garnering continuing attention and academic support."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-031",
      "id": "ap_ntb-031-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" Beginning in the mid-twentieth century, a form of dispensationalism arose out of the classical dispensationalism of John Nelson Darby (1800–1882), C. I. Scofield (1843–1921), and Lewis Sperry Chafer (1871–1951). Referred to or identified as “revised,” “normative,” or “essentialist” dispensationalism, this more traditional form has been advocated by Ryrie, John Walvoord, Dwight Pentecost, and Alva McClain, and has received ongoing support from Elliott Johnson, Robert Thomas, Michael Stallard, H. Wayne House, Thomas Ice, and others."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-032",
      "id": "ap_ntb-032-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" Developments in dispensational theology have resulted in the rise "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "role": "doc-pagebreak",
      "title": "15"
    }
  }, [_vm._v("of progressive dispensationalism, and this view is advanced by Blaising, Bock, Robert Saucy, Bruce Ware, and others."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-033",
      "id": "ap_ntb-033-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" While the family resemblances are enough to categorize progressive and more traditional dispensationalism together, there are key differences that distinguish them, namely in how they understand interpretation, the kingdom of God, and the new covenant.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Traditional forms of dispensationalism.")]), _vm._v(" One of the hallmarks of a more traditional dispensational view involves hermeneutics. This form of dispensationalism affirms a strict literal hermeneutic that focuses on the human author’s intent within the historical context. As David Mappes and H. Wayne House explain, “Rather than re-interpret the OT or practice a complementary hermeneutic, traditional dispensationalists seek to understand the "), _c('i', [_vm._v("literal meaning of a text by its immediate historical-textual parameters")]), _vm._v(" and then understand how this meaning relates to God’s overall program. This system of interpretation allows the immediate historical context of a passage to define and limit textual meaning.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-034",
      "id": "ap_ntb-034-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" On the issue of the expansion of meaning in the progress of revelation or with how later authors appropriate earlier texts, traditional dispensationalists find that meaning “is stable in spite of the perspective gained by further revelation.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-035",
      "id": "ap_ntb-035-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" There is only one "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "role": "doc-pagebreak",
      "title": "16"
    }
  }, [_vm._v("single meaning as that meaning is fixed in the context of its original historical setting, no matter how the NT uses the OT. As a result, normative dispensationalists claim that consistency in utilizing a plain or literal hermeneutic requires the literal fulfillment of Israel’s promises and prophecies be met with Israel’s future possession of the Promised Land and reception of all the national blessings.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A second distinctive of traditional dispensationalism involves the kingdom of God and inaugurated eschatology (the "), _c('i', [_vm._v("already-not yet")]), _vm._v(" framework). Most traditional or revised dispensationalists made modifications to their conception of the kingdom by rejecting the classical distinction between the kingdom of God and the kingdom of heaven held by their predecessors. Nevertheless, unlike progressive dispensationalists, the kingdom is not a singular, unified theme, and if the kingdom is present in the current dispensation (after Christ’s work on the cross), aside from God’s sovereign rule, it is only manifested in a spiritual or mystery form."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-036",
      "id": "ap_ntb-036-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" Traditional dispensationalists also reject inaugurated eschatology and specifically the "), _c('i', [_vm._v("already-not yet")]), _vm._v(" framework that is affirmed in progressive dispensationalism, covenant theology, and progressive covenantalism."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-037",
      "id": "ap_ntb-037-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "role": "doc-pagebreak",
      "title": "17"
    }
  }, [_vm._v("Traditional dispensationalists are unified with earlier or classical dispensationalists in maintaining the offer, rejection, total postponement, and complete future fulfillment of the Davidic kingdom."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-038",
      "id": "ap_ntb-038-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" Jesus offered the Davidic kingdom to Israel; however, it was contingent upon their response, and given their rejection, the kingdom was postponed."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-039",
      "id": "ap_ntb-039-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" Accordingly, Jesus is not currently ruling from the Davidic throne, but he will do so in his reign during the millennium."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-040",
      "id": "ap_ntb-040-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Given this view of the kingdom, with the fulfillment of Israel’s promises as well as the earthly mediatorial kingdom postponed until after Christ’s return, the presence of the church is a parenthesis in relation to God’s program with Israel."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-041",
      "id": "ap_ntb-041-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" Mappes and House write, “There is only one people of God soteriologically in the sense that everyone in any time period is saved by God’s grace; thus, they mutually share in some of God’s promises. There are, however, two distinct peoples/programs of God historically and teleologically in accomplishing God’s purpose of glorification.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-042",
      "id": "ap_ntb-042-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Israel is an object of unique privilege and blessing because of her national election and because God entered into unconditional covenants that "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "role": "doc-pagebreak",
      "title": "18"
    }
  }, [_vm._v("featured physical and material promises. The church, however, is structured differently, with its distinct dispensational placement and purpose in the age of grace. According to Ryrie, “The church as a living organism in which Jew and Gentile are on equal footing is the mystery revealed only in New Testament times and able to be made operative only after the cross of Christ.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-043",
      "id": "ap_ntb-043-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" While blessings to Gentiles are predicted in the OT, the co-equality and inclusion of Jews and Gentiles in the one body of Christ and the church as an organism indwelt by Christ were not previously revealed. This shows that the church is something new and different from national Israel."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-044",
      "id": "ap_ntb-044-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" Last, although Jews and Gentiles share in salvation, given the traditional dispensational understanding of two peoples with two purposes, Israel and the church as distinct anthropological groups will continue throughout eternity."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-045",
      "id": "ap_ntb-045-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Third, another area beside the kingdom where the traditional dispensational commitment to a strict, literal hermeneutic is demonstrated is with regard to the new covenant. Among traditional dispensationalists, at least three to four differing views of the new covenant may be discerned."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-046",
      "id": "ap_ntb-046-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" First, prominent dispensationalists have argued that there are two new covenants, one for Israel, and one for the church."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-047",
      "id": "ap_ntb-047-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" OT and NT texts refer to the new covenant with Israel, which will be completed in the millennial kingdom. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "role": "doc-pagebreak",
      "title": "19"
    }
  }, [_vm._v("Other NT passages (1 Cor 11:25; 2 Cor 3:6) address a new covenant that is enjoyed by the church in the present age.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A second position is that the new covenant is for Israel alone, and as the sole and exclusive covenant partner, Israel will receive the fullness of the new covenant in the eschaton."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-048",
      "id": "ap_ntb-048-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" The new covenant is actually not applied to the church in any manner in the NT. The salvation blessings in the church age are only similar to those promised to Israel under the new covenant. The similarities are only due to the fact that the church is in relationship with the same new covenant mediator, Jesus Christ.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A third view popular among traditional dispensationalists, with some variation, is that there is one new covenant, but in some manner the church participates in the blessings or benefits of the new covenant ratified by Christ."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-049",
      "id": "ap_ntb-049-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" Important for this view is that the church’s experience of the blessings and provisions of the new covenant (soteriological in nature), as well as the ratification of the new covenant in the death of Christ, in no way means that the new covenant is fulfilled either partially or in terms of inauguration. With Israel as the covenant partner of the unconditional and prophesied new covenant, the fulfillment of this covenant must occur with the second coming of Christ.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Progressive dispensationalism.")]), _vm._v(" As discussed earlier, there is much overlap between progressive dispensationalists and more traditional dispensationlists when it comes to affirming the essential distinction between Israel and the church. However, there are significant differences when considering hermeneutics, the kingdom of God, and the Davidic and new covenants.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A point of much debate among dispensationalists is the complementary hermeneutic that is employed in progressive dispensationalism. Blaising and "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "role": "doc-pagebreak",
      "title": "20"
    }
  }, [_vm._v("Bock describe, “According to this approach, the New Testament does introduce change and advance; it does not merely repeat Old Testament revelation. In making complementary additions, however, it does not jettison old promises. The enhancement is not at the expense of the original promise.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-050",
      "id": "ap_ntb-050-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The original authorial intent with applications or implications of that meaning is not eschewed in this dispensational framework, but the progress of revelation brings complementary aspects of meaning as additional elements of the text’s message take added shape."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-051",
      "id": "ap_ntb-051-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" Progressive dispensationalists, then, offer a multilayered reading of the text in accounting for the near context and in consideration of the intertextual literary connections that occur in the more distant contexts."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-052",
      "id": "ap_ntb-052-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" The significance of this approach as this method is "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "role": "doc-pagebreak",
      "title": "21"
    }
  }, [_vm._v("worked out is that more continuity between Israel and the church is affirmed than there is in the more traditional approach. Rather than there being two peoples of God with separate programs or understanding the church as a parenthesis in God’s plan, there is one people of God as the church overlaps with Israel to a degree, and the church is deemed a vital phase of the kingdom program, fitting within the one plan of holistic redemption."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-053",
      "id": "ap_ntb-053-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Another crucial difference between traditional and progressive dispensationalism is the kingdom of God theme in the form of inaugurated eschatology (the "), _c('i', [_vm._v("already-not yet")]), _vm._v(" framework). Saucy articulates that the newer form of dispensationalism found it “preferable to interpret this age as the first phase of the fulfillment of the one promised Messianic kingdom. The present age involves the spiritual aspects of the Messianic kingdom. . . . The remainder of the promises including those concerning Israel and the nations will find their fulfillment following the second advent.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-054",
      "id": "ap_ntb-054-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The eschatological kingdom is present in the person of king Jesus, who displays, through his appearing and in his messianic and salvific work, the characteristics of the kingdom, but the kingdom is also a present reality through the church, the first institutional appearance of kingdom citizens."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-055",
      "id": "ap_ntb-055-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "role": "doc-pagebreak",
      "title": "22"
    }
  }, [_vm._v("The "), _c('i', [_vm._v("not yet")]), _vm._v(" aspects of the kingdom, the fullness of the kingdom, await Christ’s return, when all of national Israel’s promises will come to fruition, and God’s enemies will be judged (occurring in the millennial and consummative phases of the kingdom). The progressive dispensational understanding of the kingdom, therefore, is an inaugurated eschatology that is similar to George Eldon Ladd’s version and the positions of covenant theology and progressive covenantalism, but it differs from Ladd’s and the covenantal positions by placing many aspects of the OT promises to Israel into the future manifestation of the kingdom."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-056",
      "id": "ap_ntb-056-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" The use of inaugurated eschatology is especially exemplified in their view that Christ is presently reigning as the Davidic king and currently seated on David’s throne."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-057",
      "id": "ap_ntb-057-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Last, the hermeneutical approach of progressive dispensationalism significantly differs from the traditional dispensational position when it is worked out in regard to the new covenant. Advocates of progressive dispensationalism recognize there is one new covenant, and it is established by the work of Christ. Although the new covenant in the OT context has Israel as the covenant partner, Saucy observes, “The fact that the prophetic statements are addressed only to Israel cannot logically be understood to "), _c('i', [_vm._v("exclude")]), _vm._v(" others from participating even though they are not a part of Israel. The texts "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "role": "doc-pagebreak",
      "title": "23"
    }
  }, [_vm._v("never say that the covenant would relate only to Israel and not others.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-058",
      "id": "ap_ntb-058-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" The new covenant is extended to Gentiles since it restates or brings to fulfillment the promises of the Davidic and Abrahamic covenant as the universal blessing to all families (Gen 12:3). And the promise of reconciliation with the nations (e.g., Is 55:3-5) comes to initial fruition through the death of Christ, which also enacts the new covenant."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-059",
      "id": "ap_ntb-059-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" The participation of Gentiles in the new covenant does not mean that they become part of a “new Israel.” The new covenant promises involving the restoration of national Israel and the physical and material blessings (i.e., the land promises), including the hope of Israel becoming a great nation (Gen 12:2), are provisions of the new covenant that await future fulfillment."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-060",
      "id": "ap_ntb-060-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Progressive covenantalism.")])]), _vm._v(" In more recent times, a mediating position between covenant and dispensational theology has been articulated and presented. Primarily through the work of Stephen Wellum and Peter Gentry, progressive covenantalism (PC) has emerged as a significant alternative to the marquee evangelical systems of theology. The position is elucidated in the key work "), _c('i', [_vm._v("Kingdom Through Covenant ")]), _vm._v("and developed further in a multi-authored work titled "), _c('i', [_vm._v("Progressive Covenantalism")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-061",
      "id": "ap_ntb-061-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" The view has also received "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "role": "doc-pagebreak",
      "title": "24"
    }
  }, [_vm._v("attention at the national Evangelical Theological Society as various scholars committed to the position have presented papers at sessions devoted to PC and its further development. While the name of this position may suggest that PC is a nuanced form of covenant theology in a manner similar to how "), _c('i', [_vm._v("progressive")]), _vm._v(" dispensationalism is to traditional dispensationalism, this would be an incorrect inference."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-062",
      "id": "ap_ntb-062-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" The PC label is based on the following: “"), _c('i', [_vm._v("Progressive ")]), _vm._v("seeks to underscore the unfolding nature of God’s revelation over time, while "), _c('i', [_vm._v("covenantalism")]), _vm._v(" emphasizes that God’s plan unfolds "), _c('i', [_vm._v("through ")]), _vm._v("the covenants and that "), _c('i', [_vm._v("all ")]), _vm._v("of the covenants find their fulfillment, "), _c('i', [_vm._v("telos")]), _vm._v(", and terminus in Christ.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-063",
      "id": "ap_ntb-063-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" The kingdom of God, God’s saving reign, is worked out through the biblical covenants. According to the PC position, the covenants are not necessarily the center of biblical theology or the unifying theme of Scripture, but they do form the “backbone” of Scripture’s metanarrative or storyline."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-064",
      "id": "ap_ntb-064-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" Furthermore, PC seeks to understand each biblical covenant—the creation covenant, the Noahic covenant, the Abrahamic covenant, the Mosaic covenant, the Davidic covenant, and the new covenant—in their own redemptive-historical context before drawing conclusions regarding how the covenants are related to each other. God’s one, eternal, redemptive plan progresses and is revealed through the covenants as God’s covenantal "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "role": "doc-pagebreak",
      "title": "25"
    }
  }, [_vm._v("promises, instruction, and stipulations converge and climax in Jesus Christ and are applied to the church, which is God’s new covenant community, the eschatological new creation and new humanity in Christ (2 Cor 5:17; Gal 6:15; Eph 2:15)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-065",
      "id": "ap_ntb-065-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("With this overview in place, there are specific areas that clearly distinguish PC from dispensationalism and covenant theology. First, PC rejects the structuring of redemptive history in terms of the covenant of works and "), _c('i', [_vm._v("the ")]), _vm._v("covenant of grace as formulated in traditional covenant theology (see above). For PC, each biblical covenant contributes to the unfolding of God’s eternal plan, starting in creation/Adam and reaching its fulfillment in Christ and the new covenant. While not employing a strictly literal hermeneutic, as in traditional dispensationalism, or a complementary hermeneutic, as found in progressive dispensationalism, a grammatical-historical-canonical hermeneutic is applied in PC where the near context, the larger biblical-theological plot structure, and the canonical horizon are together brought to bear in the interpretation of texts."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-066",
      "id": "ap_ntb-066-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Based on these hermeneutical differences and the doing of biblical theology, PC proponents find that covenant and dispensational theologies do not account for one or more of the covenants in their redemptive-historical context and how they contribute to the progress of God’s plan, which leads to misconstruing the plotline of Scripture and results in faulty theological conclusions. One of the significant differences with both camps is that PC does not categorize the covenants as either "), _c('i', [_vm._v("unconditional ")]), _vm._v("or "), _c('i', [_vm._v("conditional")]), _vm._v(", but argues that each covenant, starting in creation/Adam, exhibits elements of both unconditionality (God always takes the initiative; he alone keeps his promises) and conditionality (God demands from every creature perfect obedience and covenant loyalty), even while some are more promissory and "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "role": "doc-pagebreak",
      "title": "26"
    }
  }, [_vm._v("others more obligatory."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-067",
      "id": "ap_ntb-067-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" When this understanding of covenants is tied to the subject of typology, the differences between PC, covenantalism, and dispensationalism really surface. For example, in the Abrahamic covenant, dispensationalism posits that God’s promise of the land to Abraham is an unconditional promise and not a type, and thus it remains a promise to be fulfilled. Covenant theology disagrees with this point, but it does not view the genealogical principle—the promise to Abraham and his offspring (Gen 17:7)—in a typological manner but as a feature that is operative and constant throughout every administration of "), _c('i', [_vm._v("the")]), _vm._v(" covenant of grace. PC contends that both views are incorrect. Instead, the land promise "), _c('i', [_vm._v("and")]), _vm._v(" the genealogical principle must first be understood in their respective covenantal context before carefully observing their development through the covenants and then how they are ultimately fulfilled typologically in Christ. In Christ, the land, which reaches back to creation/Eden and looks forward to the dawning of the new creation, is inaugurated by Christ through his resurrection. Furthermore, Christ, who is the true seed of Abraham, ratifies a new covenant that constitutes a faithful people who have been circumcised of heart and who all exemplify the faith of Abraham."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-068",
      "id": "ap_ntb-068-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The interpretation of the new covenant is also a key area of difference among all of the views. The PC interpretation posits that the new covenant is not just another administration of the covenant of "), _c('i', [_vm._v("grace")]), _vm._v("; it is the culminating covenant that all of the previous covenants and promises have been pointing toward and, as such, in the new covenant all of the previous covenants have reached their fulfillment, allowing for the inaugurated eschatology sense of the NT (hence the reason why creation order and the creation structures of the Noahic covenant continue until Christ consummates what he inaugurated). According to PC, the prophesied new covenant, which Christ ratified on the cross, pointed to a regenerate and restructured covenant community because all in the new covenant community know God, are fully forgiven, and have the law written on the heart. This is a significant contrast to traditional covenant theology, which maintains that "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "role": "doc-pagebreak",
      "title": "27"
    }
  }, [_vm._v("the genealogical principle and “mixed” nature of the church continues in the post-Christ era, despite the ratification of the new covenant. PC also views the new covenant restoration promises as being fulfilled in Christ and refracted through Christ to the church—a church that is the forever people of God, the new covenant community that does not disappear and give way to various nations in the future."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-069",
      "id": "ap_ntb-069-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" Not surprisingly, this is a substantial point of disagreement with how dispensationalists interpret the new covenant, and how they view the church as a temporary, present-day illustration of the spiritual unity that Israel and the nations will exhibit in the millennium and beyond.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The PC interpretation of the covenants and their interrelationship leads to other areas of disagreement with covenant theology and dispensationalism. In contrast to covenant theology, PC rejects the tripartite distinction of the law (moral, civil, ceremonial) as the primary means to establish what is binding on the church today,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-070",
      "id": "ap_ntb-070-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" is non-Sabbatarian,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-071",
      "id": "ap_ntb-071-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" and would not view the church as a “mixed community” consisting of believers and unbelievers."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-072",
      "id": "ap_ntb-072-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" PC is a Baptist biblical theology and would differ from paedobaptist covenant theology on this point as well."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-073",
      "id": "ap_ntb-073-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" In contrast to dispensationalism, PC views more continuity between Israel and the church than dispensationalism would allow. There is no future restoration of "), _c('i', [_vm._v("national/political")]), _vm._v(" Israel in the PC scheme."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-074",
      "id": "ap_ntb-074-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" There may be a future ingathering of "), _c('i', [_vm._v("ethnic")]), _vm._v(" Jews into the church, but PC is a non-dispensational position."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-075",
      "id": "ap_ntb-075-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])]), _vm._v(" According to the PC "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "role": "doc-pagebreak",
      "title": "28"
    }
  }, [_vm._v("view, since Christ is both the antitypical and true Israel and last Adam, the agent of restoration who brings to fruition Israel’s promises and fulfills all of the biblical covenants starting in creation, the church, through him, is the one and only new covenant community. The church does not replace or absorb OT Israel; rather, Israel, as a corporate Adam, was a type of Jesus and derivatively of a new and regenerate covenant community. In this way, how PC understands the Israel-Christ-church relationship in typological terms, through the progression of the covenants, means the PC view “avoids the direct unification of Israel and the church as promulgated in covenant theology, while also evading the separation of Israel and the church with each having distinct plans as portrayed in dispensational theology.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-076",
      "id": "ap_ntb-076-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-002"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("OTHER POSITIONS ON THE CONTINUITY/DISCONTINUITY SPECTRUM")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("There have been other options presented as alternatives to the systems chosen in this book. However, for various reasons they were not deemed to have broad enough appeal in wider evangelicalism for representation in the current project."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-077",
      "id": "ap_ntb-077-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" Below are overviews of Reformed Baptist Covenant Theology and new covenant Theology, two views that occupy the middle space between the traditional covenant and dispensational views but positions that we think have not cultivated the status as serious contenders as progressive covenantalism has."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-078",
      "id": "ap_ntb-078-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Other views worth mentioning are theonomy and the promise theology of Walter Kaiser Jr. Theonomy, or Christian Reconstructionism, which is a form of covenant theology, features more continuity than traditional covenant theology because in this view of the Mosaic law-covenant, not only "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "role": "doc-pagebreak",
      "title": "29"
    }
  }, [_vm._v("are the moral laws applicable today, but so are the civil laws."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-079",
      "id": "ap_ntb-079-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" Only the ceremonial laws are fulfilled on account of Christ’s sacrifice. While this perspective drew a fair amount of attention in the 1980s and 1990s, since then it appears the view has waned. More toward the discontinuity side of the spectrum is Kaiser’s proposed “promise theology” or “epangelical” approach. Kaiser’s view differs from covenant theology and older forms of dispensationalism, but it generally agrees with progressive dispensationalism in affirming a distinction, not a separation, between Israel and the church, for the church is part of the faithful remnant grafted into Israel."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-080",
      "id": "ap_ntb-080-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" Kaiser argues that his perspective agrees with the covenantal view in that there is one plan of salvation and one people of God, but the distinguishable aspects between Israel and the church, including God’s promises to ancient Israel, like the land promise, are yet for ethnic Israel. This means that Kaiser’s "), _c('i', [_vm._v("epangelicalism")]), _vm._v(" is not far from progressive dispensationalism.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Reformed Baptist covenant theology.")])]), _vm._v(" Two other positions deserve mention, but for the reasons above were not included as positions in this book. First, some among the Reformed Baptist tradition have also developed their own covenant theology, which is credobaptist, in distinction from the decidedly paedobaptist formulation of traditional covenant theology. While Reformed Baptists throughout the last sixty years have held to a covenantal theology that varied little from their paedobaptist cousins (other than disagreeing over the proper subjects and mode of baptism),"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-081",
      "id": "ap_ntb-081-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" in more recent years a new formulation has become popular. This version of Reformed Baptist covenant theology is often referred to as 1689 Federalism because it is an attempt to rearticulate the covenant theology that proponents believe is represented in the 1689 Second London Confession of Faith. 1689 Federalism shares some similarities with progressive "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "role": "doc-pagebreak",
      "title": "30"
    }
  }, [_vm._v("covenantalism, such as a greater emphasis on the progressive unfolding of redemptive history through the covenants, a distinctively credobaptist formulation of the covenants, the church as a regenerate, believing people, and a recognition that traditional covenant theology does indeed lead to paedobaptism."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-082",
      "id": "ap_ntb-082-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" Nevertheless, they retain the superstructure of traditional covenant theology, emphasizing the covenant of works and grace, as well as holding to the tripartite division of the law and sabbatarianism."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-083",
      "id": "ap_ntb-083-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" While emphasizing the covenant of grace, 1689 Federalism does differ from traditional covenant theology in claiming that the covenant of grace is equated to and fully revealed in the new covenant."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-084",
      "id": "ap_ntb-084-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" Other Reformed Baptists do not accept the notion that the covenant of grace is the new covenant but would affirm that the progressive revelation of the covenant of grace does not lead to including infants in the new covenant."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-085",
      "id": "ap_ntb-085-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" Given these similarities and differences with traditional covenant theology and progressive covenantalism, this view would fall between the two on the continuity/discontinuity spectrum.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("New covenant theology.")])]), _vm._v(" New Covenant Theology (NCT)"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-086",
      "id": "ap_ntb-086-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" is the name given to a view that has developed as a grass roots movement through self-publishing houses, small pastors’ and church conferences, websites, and "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "role": "doc-pagebreak",
      "title": "31"
    }
  }, [_vm._v("podcasts over the last thirty to forty years."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-087",
      "id": "ap_ntb-087-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" In general, NCT fits theologically somewhere between covenant theology and dispensationalism, and depending on the representative of NCT, it can be considered fairly similar to either progressive covenantalism or progressive dispensationalism. Like progressive covenantalism, NCT explicitly argues for credobaptism. As a theological system, NCT is very difficult to define since it lacks definitive scholarly representation and, with the diversity of its advocates, it is clearly not monolithic."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-088",
      "id": "ap_ntb-088-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" NCT rejects the superstructure of covenant theology, namely the covenants of works/grace framework, but it also departs from dispensationalism in asserting the hermeneutical priority of the NT over the OT. Some in the NCT movement reject the covenant of redemption (though affirming one eternal plan of redemption), the covenant of creation in Genesis 1–3, the gracious nature of the Mosaic covenant, and the imputation of Christ’s active obedience, four points that progressive covenantalism affirms."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-089",
      "id": "ap_ntb-089-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" Despite the efforts of some, NCT has remained primarily focused on the nature of the law and its fulfillment in Christ, rejecting the tripartite distinction of the law, and has not developed into a full-orbed theological system.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("FOUR VIEWS ON SYSTEMS OF THEOLOGY:"), _c('br'), _vm._v("AN EVANGELICAL DIALOGUE")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The purpose of this book to foster friendly but also substantial debate among four different systems of theology. Given the variety of positions outlined above, not every position can be covered, but four of the most prominent and popular views within evangelicalism are presented and advocated in this work. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "role": "doc-pagebreak",
      "title": "32"
    }
  }, [_vm._v("Representatives of each view offer an essay explaining and defending their position and why their proposal best accords with the Bible. After the main presentations, each contributor has written a response to the other three positions. While the four main views were introduced above more in terms of chronological order (covenant theology, traditional dispensationalism, progressive dispensationalism, and progressive covenantalism), the four views presented in the chapters that follow move from most continuity to most discontinuity between the OT and NT. The order of presentations is: (1) covenant theology, presented by Michael Horton; (2) progressive covenantalism, presented by Stephen Wellum; (3) progressive dispensationalism, presented by Darrell Bock; and (4) traditional dispensationalism, presented by Mark Snoeberger. Each representative has written extensively on their view. Michael Horton is a long-time professor of theology at Westminster Seminary California, prolific author, and significant evangelical scholar. Horton is one of the most well-known covenant theologians, particularly through his book "), _c('i', [_vm._v("Introducing Covenant Theology")]), _vm._v(" and his systematic theology, "), _c('i', [_vm._v("The Christian Faith: A Systematic Theology for Pilgrims on the Way")]), _vm._v(". Next, Stephen Wellum has taught many years as a systematic theology professor at The Southern Baptist Theological Seminary in Louisville, Kentucky. He is the most prominent proponent of progressive covenantalism as evidenced by his contribution in "), _c('i', [_vm._v("Kingdom Through Covenant ")]), _vm._v("and "), _c('i', [_vm._v("Progressive Covenantalism: Charting a Course Between Dispensational and Covenant Theologies")]), _vm._v(", as well as other essays. Darrell Bock, alongside Craig Blaising, has been a key and crucial advocate of progressive dispensationalism for over thirty years. He is a senior research professor of New Testament at Dallas Theological Seminary, and his area of expertise is broad, as attested by his many works, including major commentaries. Bock has written extensively on progressive dispensationalism over the years through his works with Blaising ("), _c('i', [_vm._v("Progressive Dispensationalism ")]), _vm._v("and "), _c('i', [_vm._v("Dispensationalism, Israel and the Church")]), _vm._v(") and his many articles. Last, Mark Snoeberger defends the traditional dispensational view. He is a professor of systematic theology and apologetics at Detroit Baptist Theological Seminary, where he has taught courses on dispensationalism. Snoeberger has published articles on dispensationalism and the history of dispensationalism."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-090",
      "id": "ap_ntb-090-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "role": "doc-pagebreak",
      "title": "33"
    }
  }, [_vm._v("As the reader studies and evaluates each position, here is a list of questions to think through and keep in mind. These questions were also posed to the authors as a guide in the consideration of their presentation.")])]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("What hermeneutical principles govern your reading and synthesis of the whole Bible? Does the OT or NT have hermeneutical priority?")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("What is the relationship between the biblical covenants (e.g., creation, Abrahamic, Mosaic, Davidic, and new)? Which covenants are fulfilled in Christ’s first coming, which are not, and why? If certain covenants are only partially fulfilled, then when will they be fulfilled?")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("How do you understand inaugurated eschatology, and what bearing does it have for interpreting OT restoration promises for the nation of Israel? How do you understand inaugurated eschatology in relation to the Abrahamic, Davidic, and new covenants?")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("How is the promise of the land to Israel fulfilled? Are national Israel and the land promise typological of greater realities that are fulfilled in Christ and the new creation? Why or why not?")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("What is the relationship between the NT church and the OT people of God, the nation of Israel?")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("Related to the questions above, apart from a future mass salvation of ethnic Jews in the future (which advocates of all theological systems can affirm), will there be a national restoration of national/ethnic Israel? How do the OT and NT support or deny such a conclusion? If so, what role does national Israel have in the millennium and the consummation? Furthermore, are nationalistic distinctions among God’s people eternal—do they continue on after the consummation?")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d79414a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap1.vue
// module id = 69
// module chunks = 0